import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const PrivacyPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="bg-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">{t.privacyPolicy}</h1>
          
          <div className="prose prose-lg text-gray-700 max-w-none">
            <p className="lead text-xl mb-8">
              {t.lastUpdated}: {new Date().toLocaleDateString(language === 'hr' ? 'hr-HR' : 'en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.introduction.title}</h2>
            <p>{t.privacy.introduction.content}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.informationCollection.title}</h2>
            <p>{t.privacy.informationCollection.subtitle}</p>
            <ul className="list-disc pl-6 mb-6">
              {t.privacy.informationCollection.directInfo.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t.privacy.informationCollection.automaticSubtitle}</p>
            <ul className="list-disc pl-6 mb-6">
              {t.privacy.informationCollection.automaticInfo.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.informationUse.title}</h2>
            <p>{t.privacy.informationUse.subtitle}</p>
            <ul className="list-disc pl-6 mb-6">
              {t.privacy.informationUse.uses.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.dataRetention.title}</h2>
            <p>{t.privacy.dataRetention.content}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.dataSharing.title}</h2>
            <p>{t.privacy.dataSharing.subtitle}</p>
            <ul className="list-disc pl-6 mb-6">
              {t.privacy.dataSharing.situations.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.gdpr.title}</h2>
            <p>{t.privacy.gdpr.content}</p>
            <p>{t.privacy.gdpr.rightsSubtitle}</p>
            <ul className="list-disc pl-6 mb-6">
              {t.privacy.gdpr.rights.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.dataSecurity.title}</h2>
            <p>{t.privacy.dataSecurity.content}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.internationalTransfers.title}</h2>
            <p>{t.privacy.internationalTransfers.content}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.changes.title}</h2>
            <p>{t.privacy.changes.content}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">{t.privacy.contact.title}</h2>
            <p>{t.privacy.contact.content}</p>
            <p className="mt-4">
              {t.privacy.contact.email}: <a href="mailto:privacy@sanctionscreener.eu" className="text-blue-600 hover:text-blue-800">privacy@sanctionscreener.eu</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage; 